export function formatDocumentTitle(title: string) {
  return `${title} | Configurator`;
}
